import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mt-4" }
const _hoisted_3 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_PayCards = _resolveComponent("PayCards")!
  const _component_InputComponent = _resolveComponent("InputComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_StatusModal = _resolveComponent("StatusModal")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_edit_card_skeleton = _resolveComponent("edit-card-skeleton")!
  const _component_standart_template = _resolveComponent("standart-template")!

  return (_openBlock(), _createBlock(_component_standart_template, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeader, {
        title: "Редактирование карты",
        "back-url": "/home"
      }),
      (_ctx.currentCard)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_PayCards, {
              id: _ctx.currentCard.id,
              type: _ctx.currentCard.bank,
              "number-card": _ctx.currentCard.number,
              bank_name: _ctx.currentCard.bank_name,
              bank: _ctx.currentCard.bank,
              is_approved: _ctx.currentCard.is_approved,
              "check-icon": false,
              color: "#F5F5F8",
              "is-active": true,
              title: _ctx.currentCard.name,
              subtitle: "Редактируемая карта",
              class: "mt-4"
            }, null, 8, ["id", "type", "number-card", "bank_name", "bank", "is_approved", "title"]),
            _createElementVNode("div", _hoisted_2, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-grey text-sm" }, "Название карты", -1)),
              _createVNode(_component_InputComponent, {
                class: "mt-3",
                rounded: "lg",
                maxlength: "30",
                border: false,
                background: "bg-yellowLight",
                modelValue: _ctx.currentCard.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentCard.name) = $event)),
                model: _ctx.currentCard.name,
                onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeNumberInName()))
              }, null, 8, ["modelValue", "model"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_ButtonComponent, {
                height: "10",
                rounded: "lg",
                loading: _ctx.hasRequest,
                title: 
            _ctx.currentCard.name.length < 3 ? 'Короткое название' : 'Сохранить'
          ,
                disabled: _ctx.currentCard.name.length < 3,
                onClickAction: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClickConfirm('save')))
              }, null, 8, ["loading", "title", "disabled"]),
              _createVNode(_component_ButtonComponent, {
                class: "mt-2",
                height: "10",
                rounded: "lg",
                color: "red",
                loading: _ctx.hasRequest,
                "text-color": "white",
                title: "Удалить карту",
                onClickAction: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onClickConfirm('delete')))
              }, null, 8, ["loading"])
            ]),
            _createVNode(_component_StatusModal, {
              "button-text": "Отлично",
              type: "success",
              description: "Карта успешно удалена",
              state: _ctx.statusModalDialog,
              onConfirm: _cache[4] || (_cache[4] = ($event: any) => {
          _ctx.statusModalDialog = false;
          _ctx.$router.push('/home');
        })
            }, null, 8, ["state"]),
            _createVNode(_component_StatusModal, {
              "button-text": "Отлично",
              type: "success",
              description: "Карта успешно сохранена",
              state: _ctx.saveModalDialog,
              onConfirm: _cache[5] || (_cache[5] = ($event: any) => {
          _ctx.saveModalDialog = false;
          _ctx.$router.push('/home');
        })
            }, null, 8, ["state"]),
            _createVNode(_component_ConfirmModal, {
              "decline-button-text": "Нет",
              "confirm-button-text": "Да",
              description: `Вы действительно хотите ${_ctx.textModal} карту ${_ctx.currentCard.number}`,
              onConfirm: _ctx.onClickActionCard,
              onDecline: _cache[6] || (_cache[6] = ($event: any) => (_ctx.confirmModalDialog = false)),
              state: _ctx.confirmModalDialog
            }, null, 8, ["description", "onConfirm", "state"])
          ]))
        : (_openBlock(), _createBlock(_component_edit_card_skeleton, { key: 1 }))
    ]),
    _: 1
  }))
}